export default `
  query listChatLog($workflowId: ID!, $limit: Int, $nextToken: String) {
    listChatLog(workflowId: $workflowId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        workflowId
        type
        content
        userId
        aiOutput
        workflowVersion
        createdAt
      }
      nextToken
    }
  }
`
